import { __decorate } from "tslib";
import { AutoEncoder, field, MapDecoder, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
import { ProductPrices } from "./Product";
export const PriceListDecoder = new MapDecoder(StringDecoder, ProductPrices);
export class PriceListSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = "";
        this.description = "";
        this.priceList = new Map();
    }
}
__decorate([
    field({ decoder: StringDecoder })
], PriceListSettings.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 4 })
], PriceListSettings.prototype, "description", void 0);
__decorate([
    field({ decoder: PriceListDecoder })
], PriceListSettings.prototype, "priceList", void 0);
export class PublicPriceList extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.settings = PriceListSettings.create({});
        this.url = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], PublicPriceList.prototype, "id", void 0);
__decorate([
    field({ decoder: PriceListSettings })
], PublicPriceList.prototype, "settings", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PublicPriceList.prototype, "url", void 0);
export class PrivatePriceList extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.settings = PriceListSettings.create({});
        this.url = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], PrivatePriceList.prototype, "id", void 0);
__decorate([
    field({ decoder: PriceListSettings })
], PrivatePriceList.prototype, "settings", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PrivatePriceList.prototype, "url", void 0);
//# sourceMappingURL=PriceList.js.map